import "./Sidebar.css";
import { useState } from "react";
import { data } from "../../data/sidebar"
import { BiArrowFromRight } from "react-icons/bi";
import { MdDarkMode, MdLightMode, MdAdd } from "react-icons/md";
import SidebarItem from "./SidebarItem";
import SidebarProfile from "./SidebarProfile";
import { useGlobalState } from "../../Provider/AppProvider";
import { AiOutlineClose } from "react-icons/ai";

const Sidebar = () => {
    const { sidebarFull, showSidebar, darkMode, switchView,toggleDarkMode, toggleSidebar, hideSidebar } = useGlobalState()
    const [activeItem, setActiveItem] = useState('');
    const [subItems, setSubItems] = useState('');

    const toggleElementsVisible = (item: string) => {
        setSubItems(prev => {
            if (prev === item) return '';
            return item
        })
    }

    const handleClick = (item: string) => {
        console.log(item)
        switchView(item);
        toggleElementsVisible(item);
        setActiveItem(item);
    }

    return (
        <div className={`sidebar${!sidebarFull ? " active" : ""}${showSidebar ? " show" : ""}`}>
            
            <div className="sidebar-header">
                <h1 className="title">Basma</h1>
                <div className={`sidebar-title-icon`}>
                    <AiOutlineClose onClick={hideSidebar} className="close-icon" />
                    <BiArrowFromRight className="toggle-icon" onClick={toggleSidebar} />
                </div>
            </div>
            <button className="sidebar-issue-btn" onClick={() => handleClick('Issue Certificate')}>
                <MdAdd size={20} />
                <span className="sidebar-issue-label">Issue certificate</span>
            </button>
            <ul className="sidebar-list">
                <li className="switch-mode">
                    <button className="switch-mode-btn" onClick={toggleDarkMode}>
                        { darkMode ? <MdDarkMode /> : <MdLightMode /> }
                    </button>
                </li>
                {data.map(item => (
                    <SidebarItem 
                        subItems={subItems}
                        activeItem={activeItem} 
                        handleClick={handleClick} 
                        key={item.id} 
                        {...item} 
                    />
                ))}
            </ul>
            <SidebarProfile />
        </div>
    )
}

export default Sidebar